<template>
  <div class="breadcrumb-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <span @click="goCenter">个人中心</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-for="(value,index) in breadcrumbData" :key="index">
        <span @click="back(value.url)">{{value.name}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  // props: ['value1', 'value2'],
  props: {
    breadcrumbData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    back(url) {
      if (url) {
        this.$router.push({
          path: url
        });
      }
    },
    goCenter() {
      this.$router.push('/personal');
    }
  }
};
</script>
<style lang='scss'>
.breadcrumb-container {
  height: 20px;
  position: relative;
  .el-breadcrumb {
    height: 40px;
    position: absolute;
    top: -20px;
    display: flex;
    align-items: center;
    .el-breadcrumb__item {
      cursor: pointer;
      .el-breadcrumb__inner {
        font-size: 12px;
      }
    }
  }
}
</style>
